import { ChangeEvent, FormEvent, useState } from "react";
import { OfflineLicense } from "../../models/Licenses/OfflineLicense";
import { Box, Button, TextField } from "@mui/material";

interface Props {
  closeForm: () => void;
  generate: (offlineData: OfflineLicense) => void;
  selectedSoftwareId: number;
}

export default function GenerateOfflineLicForm({
  closeForm,
  generate,
  selectedSoftwareId,
}: Props) {
  const [licenseData, setLicenseData] = useState<OfflineLicense>({
    softwareId: selectedSoftwareId,
    validUntil: "",
  });

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    // Convert to ISO string with UTC indicator
    const utcISO = new Date(licenseData.validUntil).toISOString();

    const convertedData = {
      ...licenseData,
      validUntil: utcISO, // Send this instead of raw input
    };

    generate(convertedData);
  }

  function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setLicenseData({ ...licenseData, [name]: value });
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        label="Valid Until"
        name="validUntil"
        value={licenseData.validUntil}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        required
        type="datetime-local"
        slotProps={{ inputLabel: { shrink: true } }}
      />

      <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
        <Button type="submit" variant="contained" color="primary">
          Create
        </Button>
        <Button variant="outlined" onClick={closeForm}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
